import { render, staticRenderFns } from "./DebtDetail.vue?vue&type=template&id=de5b4e36"
import script from "./DebtDetail.vue?vue&type=script&lang=js"
export * from "./DebtDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports